var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatriots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "70px",
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Assets / Logo Icons / NFL / Patriots") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets-/-Logo-Icons-/-NFL-/-Patriots",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NE",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 70 0 70 70 0 70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6858,22.70604 C59.25374,24.69432 58.8854,19.81854 46.2042,18.9245 C29.1347,17.72092 14.79086,25.1461 3.32794,26.09754 C0.83762,26.30432 1.1606,28.37366 2.95022,28.72492 C7.27062,29.73166 11.72878,29.6037 15.80922,29.05742 C15.67216,29.38572 15.53454,29.89154 15.99038,30.2792 C17.6064,31.65078 24.10296,31.76824 26.95504,31.6043 C27.92342,31.54914 29.99066,31.35412 29.99066,31.35412 C29.40112,31.40998 28.47992,33.2038 30.42774,33.70892 C42.4655,37.07396 48.12906,42.50792 54.63094,51.06598 C57.27302,50.72886 59.76096,47.55464 58.70018,45.13166 L59.22728,43.8312 L61.17342,42.93128 L60.61566,38.59114 L63.5824,37.19604 C63.5824,37.19604 68.20282,24.79764 68.47344,23.89478 C68.74406,22.99192 68.18406,22.58844 67.68566,22.7059",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.28404,24.41236 C25.9378,24.9046 15.92388,29.6142 3.1731,27.5149 C14.47432,25.99184 23.08992,22.25958 33.5986,20.77348 L34.28404,24.41236 L34.28404,24.41236 Z M35.18354,29.2817 C30.56718,29.82504 25.21134,31.11374 17.4846,29.65998 C24.14468,29.4791 29.12938,27.25352 34.6164,26.15984 L35.18354,29.28184 L35.18354,29.2817 Z",
    id: "Shape",
    fill: "#C60C30",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2963,30.96226 C38.5126,30.2274 35.1911,32.11936 30.96296,32.53992 C45.9004,36.45362 51.36922,44.8168 55.0732,49.45122 C57.66236,48.35278 57.80236,46.10662 57.14282,45.30484 L57.80936,43.8781 L57.84002,42.9618 L59.62488,42.12824 L59.06012,37.68828 L62.4022,36.32146 L66.83026,24.21902 C59.32766,25.7733 56.89684,20.92916 46.22282,20.26836 C41.8747,19.99872 37.95904,20.1985 34.28278,20.6801 L34.88226,24.38478 C37.33898,24.30022 39.65164,24.61214 41.846,25.60894 C39.43338,25.4597 37.26254,25.65948 35.14476,26.05176 L35.67662,29.23004 C39.05972,28.86702 42.04368,28.9821 45.2963,30.96226 Z",
    id: "Path",
    fill: "#002244",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.20016,39.44234 C51.23762,42.2653 53.31144,45.39304 55.41578,48.13088 C56.48594,47.6868 56.8218,46.44682 56.46942,46.00862 L55.4505,44.75632 L56.60942,44.8245 L57.14128,43.90176 L55.70054,43.81664 L54.07738,44.1091 L55.7235,42.98364 L56.97664,43.057 L57.02312,42.34454 L55.74296,41.73246 L56.18298,41.25198 L58.55094,41.3994 L57.87026,36.13414 C56.93422,36.02018 56.14714,36.51004 55.80708,37.8616 L51.6096,37.61492 C52.20026,36.27806 53.12034,35.67662 54.86642,35.89866 C53.88684,34.5289 49.1134,34.40206 48.4393,36.5512 L52.14496,39.58332 L52.62446,42.35462 L51.10196,40.14836 C49.73304,38.9648 48.29524,38.13544 47.20044,39.44234",
    id: "Path",
    fill: "#B0B7BC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "59.62026 25.86374 59.91846 28.5082 62.8999 29.6254 60.10312 30.32498 60.37906 33.89036 57.96056 30.8777 54.34436 31.7282 56.57876 29.12966 54.73622 26.69198 57.82308 27.74982 59.62026 25.86374"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatriots);
export default __webpack_public_path__ + "static/media/Patriots.6f990d6287d40bf78b28adbeb97d0755.svg";
export { ForwardRef as ReactComponent };